import { FixedPhraseRootReference } from ".";

export class FixedPhraseComparer {
  static isSameTree(left: FixedPhraseRootReference, right: FixedPhraseRootReference): boolean {
    if (!left && !right) { return true; }
    if (!left || !right) { return false; }
    return left.tableId === right.tableId;
  }
}
